import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { LocalStorageAccessService } from '@app/core/_services/local-storage-access.service'

@Injectable({
    providedIn: 'root',
})
export class CalendarViewService {
    private allowedNumberOfDaysToShowValues = [1, 2, 3, 5, 7]
    // Subject to emit view setting changes
    private numberOfDaysToShowSubject = new BehaviorSubject<number>(
        this.getNumberOfDaysToShowInitialValue(),
    )
    // Observable for view setting changes
    numberOfDaysToShow$ = this.numberOfDaysToShowSubject.asObservable()

    private calendarStartTimeSubject = new BehaviorSubject<number | null>(null)
    public calendarStartTime$ = this.calendarStartTimeSubject.asObservable()

    constructor(private localStorageService: LocalStorageAccessService) {}

    // Helper method to get the initial value for the BehaviorSubject
    private getNumberOfDaysToShowInitialValue(): number {
        //const storedValue = localStorage.getItem(LOCAL_STORAGE_NUM_DAYS_TO_SHOW)
        const storedValue = this.localStorageService.getItem('numberOfDaysToShow')

        if (storedValue !== null) {
            const parsedValue = parseInt(storedValue, 10)

            // Check if the parsed value is one of the allowed values
            if (this.allowedNumberOfDaysToShowValues.includes(parsedValue)) {
                return parsedValue
            }
        }

        // Return the default value if storedValue is not valid
        this.localStorageService.setItem('numberOfDaysToShow', '3')
        return 3
    }

    // Method to update view setting
    setNumberOfDaysToShow(days: number) {
        if (this.allowedNumberOfDaysToShowValues.includes(days)) {
            this.numberOfDaysToShowSubject.next(days)
            this.localStorageService.setItem('numberOfDaysToShow', days.toString())
        }
    }

    setStartTimeForCalendar(startTimeMs: number): void {
        this.calendarStartTimeSubject.next(startTimeMs)
    }
}
